import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../shared/components/Common/Header';

/**
 * CreateOrder — redirects users to the correct dedicated service page.
 * The old generic order creation endpoint (/orders/shopping/, /orders/pickup-delivery/,
 * etc.) no longer exists on the backend. Each service now has its own dedicated flow.
 */
const CreateOrder = () => {
  const services = [
    {
      id: 'shop',
      title: 'Shopping',
      description: 'Shop for groceries, essentials, and more.',
      link: '/shop',
      icon: '🛍️',
    },
    {
      id: 'parcel',
      title: 'Parcel Delivery',
      description: 'Fast and reliable parcel pick-up and delivery.',
      link: '/pickup-delivery',
      icon: '📦',
    },
    {
      id: 'cargo',
      title: 'Cargo Delivery',
      description: 'Deliver large items and cargo to any destination.',
      link: '/cargo-delivery',
      icon: '🚛',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-100 to-blue-100">
      <Header />
      <div className="container mx-auto px-4 py-12 max-w-2xl">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Create New Order</h1>
        <p className="text-gray-600 mb-8">Choose the service you need:</p>

        <div className="space-y-4">
          {services.map(service => (
            <Link
              key={service.id}
              to={service.link}
              className="flex items-center gap-4 bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:border-blue-400 hover:bg-blue-50 transition-all duration-200"
            >
              <span className="text-4xl">{service.icon}</span>
              <div className="flex-1">
                <h2 className="font-semibold text-gray-800 text-lg">{service.title}</h2>
                <p className="text-gray-500 text-sm">{service.description}</p>
              </div>
              <span className="text-blue-500 font-bold text-xl">→</span>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link to="/dashboard" className="text-sm text-gray-500 hover:text-gray-700 underline">
            ← Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CreateOrder;
